import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.08048 2.9082C3.86511 2.9082 2.87988 3.89343 2.87988 5.1088V5.56096C2.87988 6.02713 3.25777 6.40502 3.72394 6.40502C4.19012 6.40502 4.568 6.02713 4.568 5.56096V5.1088C4.568 4.82578 4.79746 4.59632 5.08048 4.59632H9.21034V15.5691H7.56742C7.10128 15.5691 6.72335 15.947 6.72335 16.4132C6.72335 16.8793 7.10128 17.2572 7.56742 17.2572H10.053H10.0544H12.5414C13.0075 17.2572 13.3854 16.8793 13.3854 16.4132C13.3854 15.947 13.0075 15.5691 12.5414 15.5691H10.8985V4.59632H15.0283C15.3113 4.59632 15.5408 4.82578 15.5408 5.1088V5.56096C15.5408 6.02713 15.9187 6.40502 16.3849 6.40502C16.851 6.40502 17.2289 6.02713 17.2289 5.56096V5.1088C17.2289 3.89343 16.2437 2.9082 15.0283 2.9082H10.0544H5.08048Z"
      fill="#7876C1"
    />
  </svg>
);

const TextIcon2 = (props) => <Icon component={svg} {...props} />;

export default TextIcon2;
